import type { ReactNode } from "react";
import { AppShell } from "@/layouts/AppShell";
import { ProductTopBar } from "./ProductTopBar";

type ProductShellProps = {
  children: ReactNode;
};

/**
 * Vite product chrome: full-height shell + shared top bar.
 * Feature routes render inside the scrollable main region.
 */
export function ProductShell({ children }: ProductShellProps) {
  return (
    <AppShell data-app="product" topBar={<ProductTopBar />}>
      {children}
    </AppShell>
  );
}
